// src/lib/supabase.js
// ──────────────────────────────────────────────────────────────────────────
// Single Supabase client for the whole app. Reads credentials from .env:
//
//   REACT_APP_SUPABASE_URL = https://<your-project>.supabase.co
//   REACT_APP_SUPABASE_KEY = sb_publishable_xxx   (or the legacy anon key)
//
// If the variables are missing the app still runs — auth-gated features just
// show a "being set up" notice instead of crashing.
// ──────────────────────────────────────────────────────────────────────────

import { createClient } from '@supabase/supabase-js';

const url = process.env.REACT_APP_SUPABASE_URL;
const key = process.env.REACT_APP_SUPABASE_KEY;

export const supabaseReady = Boolean(url && key);
export const supabase = supabaseReady ? createClient(url, key) : null;
